// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__z0lo7","head":"Table_head__3mBkA","col":"Table_col__1qdtm"};